import React, { useState, useEffect, useRef } from 'react';
import { string, number, bool, array, shape, oneOfType, node, func } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import LoadingGigCardCarousel from '@fiverr-private/gig_listings/src/entries/LoadingGigCardCarousel';
import { SLIDER_BREAKPOINTS } from '../../../utils/slider/constants';
import contextEnrichment from '../../../utils/contextEnrichment';
import { LOHP_ROW } from '../../../utils/constants';

import './style.scss';

const SLIDER_BASE_NUM = 5;

const GigCarouselWrapper = ({
    boxSubTitle,
    boxClass,
    carouselPosition,
    boxTitle,
    currency,
    gigs,
    isLoading
}) => {
    const [gigCardCarouselImported, setGigCardCarouselImported] = useState(false);
    const gigCardCarouselRef = useRef(null);

    const { isTouch, pageCtxId } = getContext();

    useEffect(() => {
        const fetchComponent = async() => {
            const GigCardCarousel = await import(
                /* webpackChunkName: 'GigCardCarousel' */'@fiverr-private/gig_listings/src/entries/GigCardCarousel'
                );
            gigCardCarouselRef.current = GigCardCarousel.default;
            setGigCardCarouselImported(true);
        };
        fetchComponent();
    }, []);

    const contextEnrichmentProps = {
        carouselPosition,
        isTouch,
        currency,
        pageCtxId,
        boxClass
    };

    const enrichedContext = contextEnrichment({ ...contextEnrichmentProps });
    const boxClasses = classNames('recommendations-carousel', LOHP_ROW, boxClass);

    return (
        <div className={boxClasses}>
            <header>
                <h2>{boxTitle}</h2>
                {
                    boxSubTitle && <small>{boxSubTitle}</small>
                }
            </header>
            {gigCardCarouselImported ?
                <gigCardCarouselRef.current sliderBaseNum={SLIDER_BASE_NUM}
                    sliderBreakpoints={SLIDER_BREAKPOINTS}
                    gigs={gigs}
                    {...{ ...enrichedContext }}
                    isLoading={isLoading}
                    isInfinite/> :
                <LoadingGigCardCarousel isInfinite
                    isTouch={isTouch}
                    sliderBreakpoints={SLIDER_BREAKPOINTS}/>
            }
        </div>
    );
};

GigCarouselWrapper.propTypes = {
    gigs: array,
    boxClass: string,
    boxTitle: oneOfType([
        node,
        func
    ]),
    boxSubTitle: string,
    carouselPosition: number,
    isLoading: bool,
    currency: shape({
        name: string,
        rate: number,
        template: string,
        forceRound: bool,
        forceRoundFromAmount: number
    })
};

export default GigCarouselWrapper;
